export { default as RecipeDetailsTemplate } from './RecipeDetailsTemplate/RecipeDetailsTemplate';
export { default as RecipeDetailsTemplateStyles } from './RecipeDetailsTemplate/RecipeDetailsTemplate.module.scss';

export { default as RecipesByTagTemplate } from './RecipesByTagTemplate/RecipesByTagTemplate';
export { default as RecipesByTagTemplateStyles } from './RecipesByTagTemplate/RecipesByTagTemplate.module.scss';

export { default as RecipesLandingPageTemplate } from './RecipesLandingPageTemplate/RecipesLandingPageTemplate';
export { default as RecipesLandingPageTemplateStyles } from './RecipesLandingPageTemplate/RecipesLandingPageTemplate.module.scss';

export { default as RecipesPageTemplate } from './RecipesPageTemplate/RecipesPageTemplate';
export { default as RecipesPageTemplateStyles } from './RecipesPageTemplate/RecipesPageTemplate.module.scss';
